(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-product-related"] && !Shopify.designMode) return;
  try {
    

  function shuffleRelatedCards(cards) {
    const shuffled = [...cards];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  function chooseRelatedCards(cards, limit, previous) {
    const primary = shuffleRelatedCards(cards.filter(card => card.dataset.primary === 'true'));
    const fallback = shuffleRelatedCards(cards.filter(card => card.dataset.primary !== 'true'));
    const primaryCount = Math.min(limit, primary.length);
    const selected = primary.slice(0, primaryCount).concat(fallback.slice(0, limit - primaryCount));
    const sameSet = selected.length === previous.length && selected.every(card => previous.includes(card.dataset.productId));
    const alternatives = primary.length >= limit ? primary.slice(limit) : fallback.slice(limit - primaryCount);
    if (sameSet && alternatives.length) {
      const alternative = alternatives.find(card => !previous.includes(card.dataset.productId));
      if (alternative) selected[selected.length - 1] = alternative;
    } else if (selected.length > 1 && selected.every((card, index) => card.dataset.productId === previous[index])) {
      selected.push(selected.shift());
    }
    return selected;
  }

  function initializeRelatedCards(root = document) {
    root.querySelectorAll('[data-random-related]').forEach(section => {
      if (section.dataset.randomized === 'true') return;
      const template = section.querySelector('template[data-related-pool]');
      const grid = section.querySelector('.tw-pdp-related__grid');
      if (!template || !grid) return;
      const seen = new Set();
      const cards = [...template.content.querySelectorAll('product-card')].filter(card => {
        const id = card.dataset.productId;
        if (!id || id === section.dataset.productId || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
      const limit = Math.max(1, Math.min(4, Number(section.dataset.limit) || 4));
      const key = 'tw-related:' + section.dataset.productId + ':' + section.dataset.collectionId;
      let previous = [];
      try {
        const stored = JSON.parse(sessionStorage.getItem(key) || '[]');
        if (Array.isArray(stored)) previous = stored.filter(id => typeof id === 'string');
      } catch {}
      const selected = chooseRelatedCards(cards, limit, previous);
      if (!selected.length) return;
      grid.replaceChildren(...selected.map(card => card.cloneNode(true)));
      section.dataset.randomized = 'true';
      try {
        sessionStorage.setItem(key, JSON.stringify(selected.map(card => card.dataset.productId)));
      } catch {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeRelatedCards(), { once: true });
  } else {
    initializeRelatedCards();
  }
  document.addEventListener('shopify:section:load', event => initializeRelatedCards(event.target));

  } catch(e) { console.error(e); }
})();
})();
